export class DatabankModel{
patientCode='';
patientFullName = '';
patientFName = '';
patientLName = '';
birthDate = '';
diagnosis = '';
dateEntry = '';

marital = '';
gov = '';
nationality ='';
occupation = '';
email = '';
telMobile = '';
telHome = '';
addressHome = '';
cancerID = '';
docCode = '';
education = '';
status = '';
gender = '';
pathology = '';
ageYear = '0';
telBusin='';
compCode ='1' ;
userID ='sa' ;
modifiedDate  = '2021-01-01';
resid='0';
referredfrom = '';
  }
